export const generateOauth = grant_type => {
  return {
    grant_type,
    client_id: 2,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
    scope: "*"
  };
};
